import { useEffect, useState } from "react";
import { Layout } from "../Layout";
import PluginRoot from "./engine/PluginRoot";
import { Provider } from "react-redux";
import store from "./engine/store";
import Paper from "@mui/material/Paper/Paper";
import { CE_FEEDBACK_URL } from "../../utils/constants";
import QuillEditor from "./QuillEditor";

const EditorPage = () => {
  const [editorLoaded, setEditorLoaded] = useState(false);

  useEffect(() => {
    setEditorLoaded(true);
  }, []);

  return (
    <Layout title="Writing Workspace Preview">
      {editorLoaded && (
        <>
          <div
            id="banner"
            style={{
              position: "absolute",
              top: "53px",
              right: "0",
              height: "2.5rem",
              width: "100%",
              background: "#0B845C",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                color: "white",
                fontSize: "15px",
                fontFamily: "Helvetica",
              }}
            >
              Welcome to the preview of our new writing workspace! More features
              are on the way. In the meantime,{" "}
              <a
                href={CE_FEEDBACK_URL}
                target="_blank"
                style={{ textDecoration: "underline", fontWeight: "700" }}
              >
                let us know what you think!
              </a>
            </div>
          </div>
          <Paper
            className="hub-actions-container"
            elevation={0}
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              fontFamily: "Raleway",
            }}
          >
            <QuillEditor></QuillEditor>
          </Paper>
          {editorLoaded && (
            <Provider store={store}>
              <PluginRoot />
            </Provider>
          )}
        </>
      )}
    </Layout>
  );
};

export default EditorPage;
